module.exports = __webpack_public_path__ + "static/media/wetest-logo.3babbe65.svg";